import { jsx as _jsx } from "react/jsx-runtime";
export default function DisplayValueText(props) {
  const {
    value
  } = props;

  // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | number | true | ReactElement<any, s... Remove this comment to see the full error message
  return value ? /*#__PURE__*/_jsx("span", {
    children: value
  }) : null;
}